import { RouteRecordRaw } from "vue-router";

// xiyou 模块的全部路由定义（挂在站点根路径，供 src/router/index.ts 以 ...xiyouRoutes 展开）
// 所有页面懒加载并共用 "xiyou" chunk，模块可整体删装
export const xiyouRoutes: Array<RouteRecordRaw> = [
  {
    // 模块占据站点根路径：/ 即模块首页；官网首页已移到 /home
    // standalone：由根组件 App.vue 识别，该模块不套站点全局 layout（我是谜导航/页脚）
    path: "/",
    meta: { standalone: true },
    component: () =>
      import(/* webpackChunkName: "xiyou" */ "@/views/xiyou/layout/index.vue"),
    children: [
      {
        path: "",
        name: "XiyouHome",
        component: () =>
          import(/* webpackChunkName: "xiyou" */ "@/views/xiyou/index.vue"),
      },
      {
        path: "portal",
        name: "XiyouPortal",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/portal/index.vue"
          ),
      },
      {
        path: "detail/:id",
        name: "XiyouDetail",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/detail/index.vue"
          ),
      },
      {
        path: "fees",
        name: "XiyouFees",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/static/fees.vue"
          ),
      },
      {
        path: "help/review-mechanism",
        name: "XiyouReviewMechanism",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/static/review-mechanism.vue"
          ),
      },
      {
        path: "publish",
        name: "XiyouPublish",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/publish/index.vue"
          ),
      },
      {
        // 全站兜底：未匹配的路径统一进模块 404（官网静态路由分值高于通配符，不受影响）
        // 通配符至少一个字符，避免把根路径 / 从空路径首页子路由手中抢走
        // vue-router 4 评分规则为「按段比较，前缀相同时段数多者优先」，故不能用 (.*)* 或 (.*)
        path: ":pathMatch(.+)",
        name: "XiyouNotFound",
        component: () =>
          import(
            /* webpackChunkName: "xiyou" */ "@/views/xiyou/static/not-found.vue"
          ),
      },
    ],
  },
];
